import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent {
  @Input() currentLang = 'en';
  @Output() languageSelected = new EventEmitter<'en' | 'fr'>();

  onSelectLanguage(lang: 'en' | 'fr'): void {
    this.languageSelected.emit(lang);
  }
}
